import { render } from "./PaginationView.vue?vue&type=template&id=24c874d2"
import script from "./PaginationView.vue?vue&type=script&lang=js"
export * from "./PaginationView.vue?vue&type=script&lang=js"

import "./PaginationView.vue?vue&type=style&index=0&id=24c874d2&lang=css"

import exportComponent from "/var/www/hrm-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__